import {Operator} from "types/Operator";
import client from "services/ngage/api-client";
import {dateTime} from "services/date";

/**
 * Transform the given operator by deserializing object properties
 *
 * @internal
 * @param operator
 */
function deserialize(operator: any): Operator {
    operator.created_at = dateTime(operator.created_at)
    operator.updated_at = dateTime(operator.updated_at)

    return operator;
}

/**
 * Get the currently active operator
 */
const current = async () => {
    const response = await client.get<Operator | null>('/operator', {
        params: {
            glossary: 'v2'
        }
    })

    return response.status === 200 && response.data? deserialize(response.data) : null
}

/**
 * Identify the current operator using the given subdomain
 *
 * @param {string} subdomain
 */
const initialize = async (subdomain: string) => {
    client.interceptors.request.use(config => {
        if (!config?.headers) {
            throw new Error(`Cannot set headers, 'config.headers' is not defined`);
        }

        config.headers['X-Operator'] = subdomain

        return config
    })

    return current()
}

const operators = {
    current,
    initialize
}

export default operators